<template>
  <transition name="route-anim">   
    <div>        
        <v-jumbotron class="jumbotronhome elevation-7">
          <v-container fill-height fixed style="max-width: 1300px">
              <v-layout align-center>
              <v-flex>
                  <h3 class="home-title display-3 mb-4 mt-5"><span style="opacity: 0.55; letter-spacing: 4px;">WELCOME TO</span> PROG NOVEL</h3>
                  <p class="subheading ft-quicksand mx-5" style="width:46%;">Witness <span class="transparent">the pure</span> awesomeness.<span class="transparent"> Based on</span> electronic literature <span class="transparent">forms and the ever evolving nature of</span> world wide web technologies
                  <span class="transparent">...</span> <span class="home-title">PROGRESSIVE WEB NOVEL</span> <span class="transparent">brings the potentials of</span> web novel <span class="transparent">to the next level.</span></p>
                  <v-divider class="my-3 mt-3" style="width:66%; opacity: 0;"></v-divider>
                  <div style="margin-left:auto; margin-right:auto; width: 300px;">
                  <span class="ft-quicksand" style="letter-spacing: 4px;">ready?</span>
                  <v-spacer></v-spacer>
                  <v-btn flat style="border-top: 2px #fff solid; border-radius:0; border-bottom:0;" router to="/dynamic-stories">EXPLORE PROG NOVELS<i class="material-icons ml-1">chevron_right</i></v-btn>
                  </div>
              </v-flex>
              </v-layout>
          </v-container>
        </v-jumbotron>
         
        
        <!-- <div class="deep-purple darken-2 elevation-8" style="width: 100%; height: 64px;"></div> -->
        <v-container fixed style="max-width: 924px">            
        <v-layout my-5>
            <v-flex xs3>
            <v-card-media 
                src="static/img/flat-icons/desktop-pencil-line.svg"
                height="175px"
                contain
            ></v-card-media>
            </v-flex>
            <v-flex xs9>
            <h2 class="mb-3 text-mx-center" style="text-shadow: 2px 2px 2px purple; letter-spacing: 3.2px;">WHAT THE HELL IS THIS???</h2>
            <p class="text-box mx-3 my-2 px-5 py-4 deep-purple darken-1 elevation-7">Progressive Web Novel, well, is web novel. But we don't share the same piloshopy with the mainstream Asian web novel (China, Japan, and Korean WN). Instead, prog novels 
                focus developing our stories based on electronic literature.
            </p>
            </v-flex>          
        </v-layout>
        <v-layout my-3>
            <v-flex xs9>
            <h2 class="mb-3 text-mx-center" style="text-align:right; text-shadow: 2px 2px 2px purple; letter-spacing: 3.2px;">REINVENTING THE CRAFT</h2>
            <p class="text-box mx-3 my-2 px-4 py-4 deep-purple darken-1 elevation-7">With different forms we hoped to create different style of works. The whole purpose of the progressive web novel 
                is to reinventing the craft, to dig the real potential of web novels, and find out the best of what this new digital form of literature can offers. Our philosophy regarding web novel is, we don't 
                forget the "web" in web novel. Instead, we <i>exploit</i> it.<br/><br/>
                Check out our Lab segment for the newest experiment!
            </p>            
            </v-flex>
            <v-flex xs3>
            <v-card-media 
                src="static/img/flat-icons/green-potion-line.svg"
                height="175px"
                contain
                class="mt-4"
            ></v-card-media>
        </v-flex>
        </v-layout> 
                
        </v-container>

        <div class="mission elevation-7">
        <h2>OUR MISSION</h2>
          <v-expansion-panel class="elevation-5" light style="margin: 20px auto; max-width: 900px;">
            <v-expansion-panel-content
              v-for="i in mission"
              :key="i"
            >
              <div slot="header">{{ i.title }}</div>
              <v-card>
                <v-card-text>{{ i.text }}
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
        <v-parallax src="static/img/images/cats.webp" height="375" style="filter: saturate(67%);" dark>
          <v-layout class="team" style="width: 100%;">
            <v-flex xs8>
              <h2>#OUR TEAM</h2>
              <h3>SideKarakterGendut</h3>
              <h4>Founder, Technomancer, Penomancer</h4>
            </v-flex>
            <v-flex xs4 style="padding: 15px;">
              <!-- Begin MailChimp Signup Form -->
              <div id="mc_embed_signup" class="elevation-7">
              <form action="https://gilegati.us17.list-manage.com/subscribe/post?u=03ced0ad41d70dc781b7022a9&amp;id=e2345e16d2" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                <div id="mc_embed_signup_scroll">
                  <h4 class="email-header">Email Subscription</h4>
                  <hr class="email-line">
                  <label class="email-text" for="mce-EMAIL">Subscribe to our mailing list for news and progress</label>
                  <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_03ced0ad41d70dc781b7022a9_e2345e16d2" tabindex="-1" value=""></div>
                  <div class="clear"><input type="submit" value="SUBSCRIBE" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
                  </div>
              </form>
              </div>
            </v-flex>
          </v-layout> 
        </v-parallax>
        <div class="team">       
          
          <v-layout style="margin: 30px 0; margin-top: 100px;">
            <v-flex xs4>
            <v-card-media 
                src="static/img/flat-icons/plug.svg"
                height="175px"
                contain
                class="mb-4"
            ></v-card-media>           
            <h2 class="mb-3 text-mx-center h2-feature" style="text-shadow: 2px 2px 2px purple; letter-spacing: 3.2px; text-align: center;">OFFLINE READING</h2>
            <p class="text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7">Thanks to the service worker technology we can deliver to you an offline reading experience,
              complete with option for add to homescreen, which makes our novel feels like a native app.
            </p>
            </v-flex>         
            <v-flex xs4>
              <v-card-media 
                src="static/img/flat-icons/red-dragon-line.svg"
                height="175px"
                contain
                class="mb-4"
            ></v-card-media>
            <h2 class="mb-3 text-mx-center h2-feature" style="text-align:center; text-shadow: 2px 2px 2px purple; letter-spacing: 3.2px;">AWESOME</h2>
            <p class="text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7">Enganging animations and juicy effects would improve user experience when reading web novel. We're encouraging future prog novel authors how-to-rocks with their novels!
              <br>Be exciting!
            </p>
            </v-flex>
            <v-flex xs4>
              <v-card-media 
                src="static/img/flat-icons/open-source.svg"
                height="175px"
                contain            
                class="mb-4"    
            ></v-card-media>
            <h2 class="mb-3 text-mx-center h2-feature" style="text-align:center; text-shadow: 2px 2px 2px purple; letter-spacing: 3.2px;">OPEN SOURCE</h2>
            <p class="text-box mx-4 my-2 px-4 py-4 deep-purple darken-1 elevation-7">We're sharing because we know, alone, not even in one hundred years we could conquer the vast potential of what the web novel can offers. 
              <br/>
              <br/><strong>SO STAY TUNED!</strong>
            </p>
            </v-flex>
        </v-layout>  
        </div>
        <div class="road-map-box">
          <div class="road-map-hr" />
          <v-container class="road-map-container" style="max-width: 900px;  padding: 45px 150px;"> 
            <h2 class="road-map"># ROAD MAP</h2>
            <h3>First Demo (ETA 2019~2020)</h3>
            <p class="p-road-map">First demo using <a href="https://vuejs.org/">VueJS</a> and free assets as a prototype for e-litRPG. In the mean time, we wait for <a href="https://vuepress.vuejs.org/">VuePress</a>, VueJS based static site 
              generator to mature enough 
              to start tinkering with the e-litRPG template--the first project we've got in line.
            </p>
            <h3>Closed Alpha (ETA 2019~2021)</h3>
            <p class="p-road-map">Closed testing for contributors only.</p>
            <h3>Open Beta (ETA ???)</h3>
            <p class="p-road-map">Open for public testing and feedbacks.</p>
            <h3>First Shipping (ETA ???)</h3>
            <p class="p-road-map">Releasing VuePress template/theme for making a robust e-litRPG web novel, complete with easy CLI and markdown writing 
              right from your text editor.</p>
            <h3>Documentation & Tutorials (ETA ???)</h3>
            <p class="p-road-map">Launch of Prog Novel creator sub-domain for e-litRPG crash course.</p>
            <h3>Move on to another awesome project...</h3>
            <p class="p-road-map">Which is still far far far away from now.</p>         
          </v-container>
        </div>
    </div>
    </transition>
</template>

<script>
export default {
  data () {
    return {
      mission: [
        {title: 'Empowering Original Indie Web Novel Authors', text: 'Empowering the digital medium literature with web technologies so internet can generate great DIY web novels.'},
        {title: 'Embrace Diverse Creativity', text: 'The possible of web novel is massive. Web technologies, browsers, desktop machines, mobile phones, all that internet connects are improving at rapid pace. And web novels can too!'},
        {title: 'Reinventing the Craft', text: 'Transitioning between the regular web novel practices to progressive web novels will be daunting, maybe superfluous. However, we believe in taking a step back from the already established a chapter per day daily would benefit authors to hone their craft.'},
        {title: 'Knowledge Tank', text: 'We won\'t left you in dark place. In the future, we will compiling lots of knowledge articles reading the craft, whether web development thingy or just plain storytelling craft. Let\'s grow together!'}
      ]
    }
  }
}
</script>


<style lang="scss">
  .text-box{
    border-radius: 2px;
  }
  .material-icons.md-18 { font-size: 18px; }
  .material-icons.md-24 { font-size: 24px; }
  .material-icons.md-36 { font-size: 36px; }
  .material-icons.md-48 { font-size: 48px; }
  .home-title{
    font-family: 'Oswald', sans-serif;
    text-shadow: 2px 2px #2131AD11;
    letter-spacing: 2.8px;
    opacity: 1;
  }
  .ft-quicksand{
    font-family: 'Quicksand', sans-serif;
    line-height: 30px;
  }
  .transparent{
    opacity: 0.66;
  }
  .jumbotronhome{
    background: rgb(103,58,183);
    background: -moz-linear-gradient(147deg, rgba(103,58,183,1) 0%, rgba(143,14,166,1) 31%, rgba(26,35,126,1) 100%);
    background: -webkit-linear-gradient(147deg, rgba(103,58,183,1) 0%, rgba(143,14,166,1) 31%, rgba(26,35,126,1) 100%);
    background: linear-gradient(147deg, rgba(103,58,183,1) 0%, rgba(143,14,166,1) 31%, rgba(26,35,126,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#673ab7",endColorstr="#1a237e",GradientType=1);
  }

  /* PAGE TRANSITION */
  .page{
    position: fixed;
    width: inherit;
  }
  .route-anim-enter-active {
		-webkit-animation: fade-in-bck 0.33s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
	           animation: fade-in-bck 0.33s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  }
  .route-anim-leave-active{
    opacity: 0;
  }
  /* ----------------------------------------------
  * Generated by Animista on 2018-6-30 2:33:59
  * w: http://animista.net, t: @cssanimista
  * ---------------------------------------------- */

  /**
  * ----------------------------------------
  * animation fade-in-bck
  * ----------------------------------------
  */
  @-webkit-keyframes fade-in-bck {
    0% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
      opacity: 0;
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes fade-in-bck {
    0% {
      -webkit-transform: scale(1.1);
              transform: scale(1.1);
      opacity: 0;
    }
    100% {
      -webkit-transform: scale(1);
              transform: scale(1);
      opacity: 1;
    }
  }
  .mission{
    background: #4527A0;
    padding: 50px;
    opacity: 0.85;
  }
  .mission h2{
    font-size: 2.3em;
    letter-spacing: 0.3em;
    text-align: center;
    font-family: 'Oswald', sans-serif;
    border-top: 2px solid #fff;
    width: 308px;
    margin: 0 auto;
    padding-left: 8px;
  }
  .team{
    padding: 20px;
    max-width: 880px;
    margin: 40px auto;
  }
  .team h2{
    margin-left: 3%;
    font-size: 28px;
    letter-spacing: 3px;
    margin-bottom: 30px;
  }
  .team h3{
    color: #9575CD;
  }
  .team h4{
    font-weight: 400;
    line-height: 15px;
  }
  .team .h2-feature{
    font-size: 24px;
  }
  #mc_embed_signup{
    background:darken(#9575CD,10%);
    border: 2px solid darken(#9575CD,12.275%);
    border-radius: 2px;
    padding: 15px 24px;  
  }
  #mc_embed_signup .button{
    padding: 8px;
    width: 100%;
    background:lighten(#4527A0,15%);
    outline-color: lighten(#4527A0,10%);
    font-weight: 900px;
    letter-spacing: 2px;
    transition: all 0.1s ease-in-out;
  }
  #mc_embed_signup .button:hover{
    background:lighten(#4527A0,10%);   
    outline: solid 1px lighten(#4527A0,25%);
    transform: translateY(-2px);
  }
  .email-header{
    text-align: center;
    font-family: 'Oswald', sans-serif;
    font-size: 18px;
    margin-bottom: 9px;
  }
  .email-line{
    width: 80px;
    height: 1px;
    border-width: 0.25px;
    margin: 0 auto;
    margin-bottom: 6px;
    border-color: #fff;
    background: #fff;
  }
  .email-text{
    font-family: 'Quicksand', sans-serif;
    color: #fffd;
    line-height: 10px;
  }
  .email{
    display: block;
    margin: 10px 0 4px 0;
    width: 100%;
    padding: 3px;
    border-bottom:#fffa 1px solid;
  }
  .email:focus{
    background:#9575CD;
    color: #fffe;
    outline: 0;
  }
  .email:focus ::-moz-placeholder,
  .email:focus ::-webkit-input-placeholder{
    color: #fff;
  }
  .road-map-box{
    background: #292929;
    transition: all 0.175s ease-out;
  }
  .road-map-box:hover{
    background: #333333;
  }
  .road-map-container{
    padding: 45px 150px;       
  }
  .road-map{
    font-size: 1.4em;
    transform: translateX(-17.5px);
    color: #9575CD;    
  }
  .p-road-map{
    font-family: 'Quicksand', sans-serif;
  }
  .p-road-map a{
    font-weight: 600;
    color:#9575CD;
    transition: all 0.1s ease-in;
    text-decoration: none;
    border-bottom: #9575CD 1px solid;
  }
  .p-road-map a:hover{
    background: #9575CD;
    color: #fff;    
  }
  .road-map-hr{
    width: 0;
    height: 1.35px;
    margin: 0 auto;
    background:#9575CD;
    opacity: 0;
    transition: all 0.3s ease-in-out;
  }
  .road-map-box:hover > .road-map-hr{
    width: 100%;
    opacity: 1;
  }
</style>


// WEBPACK FOOTER //
// src/components/home.vue